<template>
  <layout-login>
    <invite-lose />
  </layout-login>
</template>

<script type="text/ecmascript-6">
import LayoutLogin from '@/components/mobile/account/LayoutLogin'
import InviteLose from '@/components/mobile/invite/InviteLose'
export default {
  components: {
    LayoutLogin,
    InviteLose
  },
  data () {
    return {
    }
  },
  methods: {
    toIndex () {
      this.$router.push({ name: 'OrgIndex' })
    }
  }
}
</script>
